import { createStore, Store } from 'vuex';
import loginStateModule from './login';
import { LoginStateInterface } from './login/state';
import createPersistedState from 'vuex-persistedstate';

export interface StateInterface {
  loginStateModule: LoginStateInterface;
}
// vue 2.x
// const mystore: Store<StateInterface> = new Vuex.Store<StateInterface>({
//   mutations: {},
//   actions: {},
//   modules: {
//     loginStateModule,
//   },
//   plugins: [createPersistedState()],
// });

const mystore: Store<StateInterface> = createStore({
  mutations: {},
  actions: {},
  modules: {
    loginStateModule,
  },
  plugins: [createPersistedState()],
});

export default mystore;
export { mystore };
